<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>

  <!-- Form Modal -->
  <vue-final-modal
      v-model="EmployeeContractModal"
      classes="base-modal"
      :ssr="true"
      :content-class="
          darkMode
              ? 'add-modal bg-darkmode-base transition-colors duration-1000'
              : 'add-modal bg-gray-100 transition-colors duration-1000'
      "
      :lock-scroll="true"
      :hide-overlay="false"
      :click-to-close="true"
      :esc-to-close="true"
      :prevent-click="true"
      :attach="false"
      transition="vfm"
      overlay-transition="vfm"
      :z-index-auto="true"
      :z-index-base="1000"
      :z-index="false"
      :focus-retain="true"
      :focus-trap="false"
      :fit-parent="true"
      :drag="false"
      drag-selector=""
      :keep-changed-style="false"
      :resize="false"
      :resize-directions="['t','tr','r','br','b','bl','l','tl']"
      :min-width="250"
      :min-height="250"
      :max-width="Infinity"
      :max-height="Infinity"
  >
      <div class="modal-head">
          <h1 v-if="showEdit">{{ $t("employeecontract.editform") }}</h1>
          <h1 v-if="isRenew">{{ $t("employeecontract.renewform") }}</h1>
          <h1 v-else>{{ $t("employeecontract.addform") }}</h1>

          <jb-button
              class="btn-close-modal"
              :icon="mdiClose"
              @click="EmployeeContractModal = false"
          />
      </div>

      <div class="modal-content">
          <EmployeeContractForm
              :prop-employee-contract="EmployeeContractObject"
              :show-edit="showEdit"
              :form-type="formType"
              @close-modal="hideModal"
              @refresh-list="refresh"
              @reset-modal="resetModal"
          />
      </div>
  </vue-final-modal>

  <div class="shadow overflow-hidden w-full max-w-4xl">
    <div class="bg-red dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 flex justify-start">
      <jb-button
        :label="$t('employeecontract.renew')"
        color="info"
        :icon="mdiRefreshCircle"
        small
        @click="renewEmployeeContract"
        class="w-auto px-8 py-2"
      />
    </div>

    <div>
      <dl>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.employee_name") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.employee_name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.contract_type_name") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.contract_type_name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.decree_no") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.decree_no }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.decree_date") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.decree_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.period_start_date") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.period_start_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.period_end_date") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.period_end_date }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.employer_name") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.employer_name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.remarks_1") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <div v-html="employeecontract.remarks_1"/>
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.remarks_2") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <div v-html="employeecontract.remarks_2"/>
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.remarks_3") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            <div v-html="employeecontract.remarks_3"/>
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
            <dt class="text-base font-medium text-gray-500 dark:text-white">
                {{ $t('employeetrainingfile.file_name') }}
            </dt>
            <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                <p
                  class="cursor-pointer text-blue-600 underline"
                  @click="downloadContractWord(employeecontract.id, employeecontract.template_file_name)"
                  :title="employeecontract.template_file_name"
                >
                  {{ employeecontract.template_file_name }}
                </p>
            </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.created_by") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.created_by }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.updated_by") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.updated_by }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.created_at") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.created_at }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeecontract.updated_at") }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ employeecontract.updated_at }}
          </dd>
        </div>

        <div>
          <main-section>
            <employeeContractFile :propEmployeeContract="employeecontract" :employeeContractId="employeecontract.id" :employeeId="employeecontract.employee_id" />
          </main-section>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { onMounted, ref, reactive, watchEffect } from "vue"
import { mdiRefreshCircle, mdiClose } from "@mdi/js"
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import CryptoJS from "crypto-js"
import axios from "axios"
import JbButtons from "@/components/JbButtons"
import JbButton from "@/components/JbButton"
import MainSection from "@/components/MainSection"
import employeeContractFile from '@/views/humanresource/employeeContractFile/Index.vue'
import EmployeeContractForm from '@/views/humanresource/employeeContract/EmployeeContractForm.vue'
import { prop } from "vue-class-component"

export default {
  name: "EmployeeContractDetail",
  components: {
    MainSection,
    Loading,
    employeeContractFile,
    JbButton,
    JbButtons,
    EmployeeContractForm
  },
  props: {
    propEmployeeContract: {
      type: Object,
      default: () => ({}),
    },

    isRenew: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const isLoading = ref(false)
    const EmployeeContractModal = ref(false)
    const EmployeeContractObject = ref({})
    const showEdit = ref(false)
    const darkMode = ref(false)
    const isRenew = ref(props.isRenew)

    const contracttemplate = ref([])
    const employeecontract = reactive({
      id: "",
      employee_id: "",
      employer_id: "",
      contract_type_id: "",
      decree_no: "",
      decree_date: "",
      period_start_date: "",
      period_end_date: "",
      remarks_1: "",
      remarks_2: "",
      remarks_3: "",
      created_by: "",
      updated_by: "",
      created_at: "",
      updated_at: "",
    })

    const employeeTrainingState = ref("Draft")

    watchEffect(() => {
      if (
        props.propEmployeeContract &&
        Object.keys(props.propEmployeeContract).length > 0
      ) {
        Object.assign(employeecontract, props.propEmployeeContract)
        employeecontract.template_file_name = props.propEmployeeContract.file_name || ''
      }
    })

    const getContractTemplate = async () => {
      try {
        isLoading.value = true
        const res = await axios.get("/contract-template")
        contracttemplate.value = res.data.data || []
      } catch (err) {
        toast.error(err.response?.data?.message || "Failed to load data")
        console.error(err)
      } finally {
        isLoading.value = false
      }
    }

    const checkUser = ref(false)

    const userCheck = () => {
      const role = localStorage.getItem("role")
      if (!role) return

      const decrypted = CryptoJS.AES.decrypt(role, "amatra1609")
        .toString(CryptoJS.enc.Utf8)
        .split(",")

      checkUser.value = decrypted.includes("ROLE_ADMIN_HRD")
    }

    const downloadContractWord = (employeeContractId, fileName) => {
      isLoading.value = true

      axios
        .get(`/employee-contract/${employeeContractId}/download-word`, { responseType: "blob" })
        .then((response) => {
          const downloadName = fileName || `Employee_Contract_${employeecontract.employee_name}.pdf`
          triggerDownload(response.data, downloadName)
        })
        .catch((error) => {
          console.error("Download contract word failed:", error)
        })
        .finally(() => {
          isLoading.value = false
        })
    }


    const triggerDownload = (blobData, filename) => {
      const fileURL = window.URL.createObjectURL(new Blob([blobData]))
      const fileLink = document.createElement("a")

      fileLink.href = fileURL
      fileLink.setAttribute("download", filename)
      document.body.appendChild(fileLink)
      fileLink.click()

      document.body.removeChild(fileLink)
      window.URL.revokeObjectURL(fileURL)
    }

    const showModal = () => {
      EmployeeContractModal.value = !EmployeeContractModal.value
    }

    const hideModal = () => {
      EmployeeContractModal.value = false
    }

    const resetModal = () => {
      EmployeeContractObject.value = {
        employee_id: employeecontract.employee_id,
        employer_id: "",
        contract_type_id: "",
        decree_no: "",
        decree_date: "",
        period_start_date: "",
        period_end_date: "",
        remarks_1: "",
        remarks_2: "",
        remarks_3: "",
      }
    }

    const refresh = () => {
      emit('refresh-list')
    }

    const formatDate = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, "0")
      const day = String(date.getDate()).padStart(2, "0")
      return `${year}-${month}-${day}`
    }

    const renewEmployeeContract = () => {
      // Auto Generate Period Date
      const start = new Date(employeecontract.period_start_date)
      const end = new Date(employeecontract.period_end_date)
      // const durationInMs = end - start
      // const durationInMs = Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1
      const durationInMs = Math.floor((end - start) / (1000 * 60 * 60 * 24))

      const newStart = new Date(end)
      newStart.setDate(newStart.getDate() + 1)

      const newEnd = new Date(newStart)
      newEnd.setDate(newEnd.getDate() + durationInMs - 1)


      EmployeeContractObject.value = {
        employee_id: employeecontract.employee_id,
        employer_id: employeecontract.employer_id,
        contract_type_id: employeecontract.contract_type_id,
        decree_no: employeecontract.decree_no,
        decree_date: employeecontract.decree_date,
        // period_start_date: employeecontract.period_start_date,
        // period_end_date: employeecontract.period_end_date,
        period_start_date: formatDate(newStart),
        period_end_date: formatDate(newEnd),
        remarks_1: employeecontract.remarks_1,
        remarks_2: employeecontract.remarks_2,
        remarks_3: employeecontract.remarks_3,
      }

      showEdit.value = false
      isRenew.value = true
      showModal()
    }

    onMounted(() => {
      userCheck()
      getContractTemplate()
    })

    return {
      mdiRefreshCircle,
      mdiClose,
      isLoading,
      employeecontract,
      employeeTrainingState,
      checkUser,
      downloadContractWord,
      showModal,
      hideModal,
      resetModal,
      refresh,
      EmployeeContractModal,
      EmployeeContractObject,
      renewEmployeeContract,
      showEdit,
      darkMode,
      contracttemplate,
      isRenew,
    }
  },
}
</script>
